import { createFileRoute } from '@tanstack/react-router';
import { Create } from '../../features/dossiers/dossier/create/create';
import {
  createPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/neu')({
  component: Create,
  beforeLoad: createPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'CONTRIBUTE'),
  ),
});

export const CreateDossierRoute = Route;
